import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = ({ setCurrentPage, currentPage }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (page, section = null) => {
    setCurrentPage(page);
    setIsMobileMenuOpen(false);
    
    if (section && page === 'home') {
      setTimeout(() => {
        const element = document.getElementById(section);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="nav-wrapper">
          <div className="logo" onClick={() => handleNavClick('home')}>
            <img src="/logo.png" alt="Prangio Designs" className="logo-image" />
          </div>
          
          <nav className={`nav ${isMobileMenuOpen ? 'nav-open' : ''}`}>
            <a href="#home" onClick={() => handleNavClick('home', 'home')}>Home</a>
            <a href="#about" onClick={() => handleNavClick('home', 'about')}>About</a>
            <a href="#services" onClick={() => handleNavClick('home', 'services')}>Services</a>
            <a href="#portfolio" onClick={() => handleNavClick('home', 'portfolio')}>Portfolio</a>
            <a href="#contact" onClick={() => handleNavClick('home', 'contact')}>Contact</a>
          </nav>

          <button 
            className={`mobile-menu-btn ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
